module.exports = __webpack_public_path__ + "static/img/stop.5b6d3b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stop.png
// module id = 163
// module chunks = 1